import { useState, useEffect } from 'react';


import axios from 'axios';

import "./PassaggioDocumentale.css"

const PassaggioDocumentale = ({})=> {

    // devo tornarmi la lista dei file zip creati dei vari bucket

    const [dataList, setDataList] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)


useEffect(() => {

      axios.get(`http://localhost:9000/s3/getDataPassaggi`)
        .then((response) => {
              setDataList([...response.data])
          })
          .catch((error) => {
              setError(error);
              setLoading(false);

          })
  }, []);




  const displayDataList = (
    dataList.map((item, index) => {
      return (
        <div key={index} className='item_dashboard'>
          <div className='azienda-title'>Azienda</div>
          <p>{item.brand}</p>
          <div className='file-title'>File Zip</div>
          <div>{item.files.map((file, index) => <p key={index}>{file}</p>)}</div>
          
        </div>
      )
    })
  )


  return (
    <div className='main-container-passaggio-documentale'>
      {displayDataList}
    </div>
  )
}

export default PassaggioDocumentale
